import { render, staticRenderFns } from "./NewAccSon.vue?vue&type=template&id=68d36106&scoped=true"
import script from "./NewAccSon.vue?vue&type=script&lang=js"
export * from "./NewAccSon.vue?vue&type=script&lang=js"
import style0 from "./NewAccSon.vue?vue&type=style&index=0&id=68d36106&prod&lang=less&scoped=true"
import style1 from "./NewAccSon.vue?vue&type=style&index=1&id=68d36106&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d36106",
  null
  
)

export default component.exports